import * as T from './types'

export default {
    [T.APP_BASE](state) {
        return state.base
    },

    [T.APPCLOUD_ID](state) {
        return state.base.appcloud_id
    },

    [T.HAS_APP_SUPPORT](state) {
        return (state.base.client || []).includes('App')
    },

    [T.HAS_MOBILE_SITE_SUPPORT](state) {
        return (state.base.client || []).includes('MobileSite')
    },
}
